var _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPatternRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 31,
    viewBox: "0 0 24 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 23.3472,
    y: 18.0208,
    width: 7.53269,
    height: 7.53269,
    rx: 1,
    transform: "rotate(135 23.3472 18.0208)",
    fill: "#A1DFFD"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.3472,
    y: 26.3679,
    width: 5.62752,
    height: 5.62752,
    rx: 1,
    transform: "rotate(135 11.3472 26.3679)",
    fill: "#A1DFFD"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14.3472,
    y: 7.17358,
    width: 10.145,
    height: 10.145,
    rx: 1,
    transform: "rotate(135 14.3472 7.17358)",
    fill: "#A1DFFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatternRight);
export default __webpack_public_path__ + "static/media/pattern-right.b55c657042f9f612f48396bf5d3ea741.svg";
export { ForwardRef as ReactComponent };